/**
 * Gates the React profile dialog against the Angular `profile.html` body.
 * The mount ticket is the only place that evaluates this. Leave it off, with
 * no targeting, until that ticket ships.
 */
export const WEBPORTAL_REACT_PROFILE_DIALOG_FLAG = 'is-webportal-react-profile-dialog';
